module.exports = __webpack_public_path__ + "media/images/rank_04-8b2d4e499e2b96ff48263b284ae9012e.png";